/* src/app/components/PaperHeader/styles.js */

export default theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    alignItems: 'center',
  },
  noPadding: {
    padding: 0,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/PaperHeader/styles.js